export default __webpack_public_path__ + "book_details-page_flip.6b0cc8b2.png";